var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4107 11.9107H17.6071C17.3212 11.9107 17.0893 11.6788 17.0893 11.3929V2.58929C17.0893 1.15936 15.9299 0 14.5 0C13.0701 0 11.9107 1.15936 11.9107 2.58929V11.3929C11.9107 11.6788 11.6788 11.9107 11.3929 11.9107H2.58929C1.15936 11.9107 0 13.0701 0 14.5C0 15.9299 1.15936 17.0893 2.58929 17.0893H11.3929C11.6788 17.0893 11.9107 17.3212 11.9107 17.6071V26.4107C11.9107 27.8406 13.0701 29 14.5 29C15.9299 29 17.0893 27.8406 17.0893 26.4107V17.6071C17.0893 17.3212 17.3212 17.0893 17.6071 17.0893H26.4107C27.8406 17.0893 29 15.9299 29 14.5C29 13.0701 27.8406 11.9107 26.4107 11.9107Z",
    fill: "#FF583D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.c77eb961287e60dc1b9293c7f0302e51.svg";
export { ForwardRef as ReactComponent };